import React, { FC, FormEvent, useState } from 'react';

import { Eye, EyeOff, KeyRound } from 'lucide-react';

import { setApiPassword } from '@/lib/api-password';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface ApiPasswordGateProps {
  isRejected: boolean;
}

export const ApiPasswordGate: FC<ApiPasswordGateProps> = ({ isRejected }) => {
  const [value, setValue] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const password = value.trim();
    if (!password) {
      return;
    }

    setApiPassword(password);
  };

  return (
    <div className="flex h-screen items-center justify-center bg-zinc-900 p-4">
      <form onSubmit={handleSubmit} className="w-full max-w-sm rounded-lg bg-white p-6 shadow-lg">
        <div className="mb-4 flex items-center gap-2">
          <KeyRound className="size-4 text-zinc-500" />
          <h1 className="text-base font-semibold text-zinc-900">API password</h1>
        </div>
        <p className="mb-4 text-sm text-zinc-500">
          {isRejected
            ? 'The server rejected the saved password. Enter it again.'
            : 'Enter the shared password used to access the backend.'}
        </p>
        <div className="relative">
          <Input
            autoFocus
            type={isVisible ? 'text' : 'password'}
            name="api-password"
            autoComplete="current-password"
            placeholder="Password"
            aria-invalid={isRejected || undefined}
            aria-label="API password"
            className="pr-9"
            value={value}
            onChange={(event) => setValue(event.target.value)}
          />
          <Button
            type="button"
            variant="ghost"
            size="icon-sm"
            aria-label={isVisible ? 'Hide password' : 'Show password'}
            className="absolute top-1/2 right-0.5 -translate-y-1/2 text-zinc-500"
            onClick={() => setIsVisible((prev) => !prev)}>
            {isVisible ? <EyeOff /> : <Eye />}
          </Button>
        </div>
        <Button type="submit" disabled={!value.trim()} className="mt-4 w-full">
          Continue
        </Button>
      </form>
    </div>
  );
};
